import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReceiveAdviceComponent } from '../receive-advice/receive-advice.component';

@Component({
  selector: 'app-button-receive-advice',
  templateUrl: './button-receive-advice.component.html',
  styleUrls: ['./button-receive-advice.component.scss']
})
export class ButtonReceiveAdviceComponent implements OnInit {

  constructor(
    public dialog: MatDialog
  ) { }
  openDialog_receive_contact(): void {
    const dialog_freetrial = this.dialog.open(ReceiveAdviceComponent, {
      width: '60%'
    });

    dialog_freetrial.afterClosed().subscribe(result => {
      
    });
  }
  ngOnInit(){
    
  }

}
